import { render, staticRenderFns } from "./ValidationWithAuth.vue?vue&type=template&id=59cfc398&scoped=true&lang=pug"
import script from "./ValidationWithAuth.vue?vue&type=script&lang=js"
export * from "./ValidationWithAuth.vue?vue&type=script&lang=js"
import style0 from "./ValidationWithAuth.vue?vue&type=style&index=0&id=59cfc398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cfc398",
  null
  
)

export default component.exports